import IconComponent from "icons/IconComponent";

import NavMenuIcon from "./nav-menu.svg";

export default (NavMenuIcon as any) as IconComponent;
